<template>
  <div id="mainview">
    <el-main>
      <div id="container" @keydown="onKeyDown($event)" @keyup="onKeyUp($event)"></div>
    </el-main>
    <video
      id="videoElement"
      crossOrigin="Anonymous"
      webkit-playsinline="“true”"
      playsinline="“true”"
    ></video>
  </div>
</template>

<script>
import Bus from "../../common/js/bus";
import * as THREE from "three/build/three.module";
import { login } from "../assets/api/index.js";
import md5 from "js-md5";
import { player } from "../player";
import Hls from "hls.js";
import flvjs from "flv.js";
// import func from 'vue-editor-bridge';
export default {
  name: "MainView",
  data() {
    return {
      flag: false,
      desc: "3D View",
      O2: {},
      selObj: {},
      SCREEN_WIDTH: 800,
      SCREEN_HEIGHT: 600,
      btnDown: {
        x: 0,
        y: 0,
      },
      mouse: {
        x: 0,
        y: 0,
      },
      mouse_down: {
        x: 0,
        y: 0,
      },
    };
  },
  methods: {
    start3D() {
      var that = this;
      let container = document.getElementById("container");
      this.SCREEN_WIDTH = container.clientWidth;
      this.SCREEN_HEIGHT = container.clientHeight;
      var _o2 = document.o2vr;

      var flvPlayer;
      var hlsPlayer;
      var videoElement;
      var screen;
      var oldMap;
      var videoTex;

      _o2.init(container);

      if (this.O2Builder) {
        let builder = this.O2Builder;
        builder.init(_o2);
      }

      // let ppp = this.O2vr.load_o2_scene(
      //   "http://localhost/web/static/builder/scene.json"
      // );
      // let ppp = this.O2vr.load_zip_scene(
      //   "http://localhost/web/static/builder/DIST/SCENE.ZIP"
      // );
      let ppp = this.O2vr.load_zip_scene(
        "https://o2res.oss-cn-beijing.aliyuncs.com/%E5%AE%9D%E9%A9%AC%E4%BA%8C%E6%9C%9F/%E6%B1%BD%E8%BD%A6%E5%B1%95%E5%8E%85webgl_v4.0.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001659318660&Signature=zzlZHzXT96PggNPERIjb24pMO%2BI%3D"
      );
      {
        let last_mouse_down = Date.now();
        _o2.script = {};
        let scripts = _o2.script;
        _o2.dist_appear = false;
        scripts["init"] = function init() {
          console.log("inited");
          screen = _o2.search_obj_by_name("screen");
          _o2.screen = screen;
          //_o2.logo = _o2.search_obj_by_name("Logo");
          // if (screen) {
          //   screen.material.color.setRGB(1, 1, 1);
          //   screen.material.lightMap = _o2.map_white;
          //   screen.visible = false;
          // }
          if (_o2.init_play) _o2.init_play();
          _o2.on_loading_msg("正在下载:", String(Math.ceil(100)), "%");
          _o2.cameraControls.target.set(0, 600, 13874);
          _o2.camera.position.set(0, -550, 17464);
          _o2.cameraControls.panSpeed = 0.5;
          _o2.cameraControls.maxDistance = 5000;
          _o2.cameraControls.minDistance = 10;
          _o2.cameraControls.maxPolarAngle = Math.PI - Math.PI / 10;
          _o2.cameraControls.minPolarAngle = Math.PI / 10;
          _o2.camera.fov = 55;
          _o2.camera.updateProjectionMatrix();
          _o2.float_animation = _o2.animation.get_timeline_by_name("float_animation");
          if (_o2.float_animation) _o2.float_animation.play();

          _o2.scene.add(_o2.playerMgr.playerNode);
          //播放动画
          let ani = _o2.animation.get_timeline_by_name("qiantai");
          if (ani) ani.play();
          ani = _o2.animation.get_timeline_by_name("Bloom");
          if (ani) ani.play();
          ani = _o2.animation.get_timeline_by_name("LightFlow_blue");
          if (ani) ani.play();

          //各个行业的动画
          _o2.fence_appear = _o2.animation.get_timeline_by_name("audio_flash");
          _o2.active_fence = _o2.search_obj_by_guid2(
            "0373979A-5421-4F6B-9D4A-4A7899CA1EAF"
          );
          _o2.default_fence = _o2.search_obj_by_guid2(
            "3C5C9CDD-FEEF-406A-BE54-8AA81033D74A"
          );
          _o2.default_fence2 = _o2.search_obj_by_guid2(
            "7118BA81-8F26-4B46-9DE1-53686A59C79B"
          );
          _o2.default_fence3 = _o2.search_obj_by_guid2(
            "6CA099E1-95FA-44A0-AEC7-4A9680C37BF6"
          );

          _o2.skeletons.forEach((e) => {
            if (e.name.indexOf("whale") != -1) {
              e.mixer.timeScale = 0.5;
            }
          });
          _o2.originPos = [0, -1120, 13874, 0, -550, 17464];
          // _o2.home_appear = _o2.animation.get_timeline_by_name("home_appear");
          // _o2.military_appear = _o2.animation.get_timeline_by_name("military_appear");
          // _o2.dt_appear = _o2.animation.get_timeline_by_name("dt_appear");
          // _o2.case_wall_appear = _o2.animation.get_timeline_by_name("case_wall_appear");
          // _o2.case_appear = _o2.animation.get_timeline_by_name("case_appear");
          // _o2.edu_appear = _o2.animation.get_timeline_by_name("edu_appear");
          // _o2.earth_core = _o2.animation.get_timeline_by_name("earth_core");
          // _o2.edu_loop = _o2.animation.get_timeline_by_name("edu_loop");
          // _o2.software1 = _o2.animation.get_timeline_by_name("software1");
          // _o2.software2 = _o2.animation.get_timeline_by_name("software2");
          // _o2.software3 = _o2.animation.get_timeline_by_name("software3");
          // _o2.software4 = _o2.animation.get_timeline_by_name("software4");
          // _o2.obj_click = _o2.search_obj_by_guid2("13A5E015-5856-4B13-B11C-967F8195D1AD");
          // _o2.case_screen = _o2.search_obj_by_guid2(
          //   "FE49C850-D5E5-4ACE-8CB2-6DF89C4FE6F8"
          // );
          // _o2.screen = _o2.search_obj_by_guid2("E55EDB96-EFCE-4937-AF18-65B99ACB4443");
          // _o2.current_solution = "";
          // if (_o2.obj_click) {
          //   _o2.click = _o2.obj_click.clone();
          //   _o2.scene.add(_o2.click);
          //   _o2.click.visible = false;
          //   _o2.click_life = 0;
          // }

          if (screen && screen.material) oldMap = screen.material.map;
          videoElement = document.getElementById("videoElement");
          _o2.screen_video = videoElement;
          if (videoElement) {
            // videoTex = new THREE.VideoTexture(videoElement);
            // screen.material.map = videoTex;
          }

          hlsPlayer = new Hls();
          Bus.$on("playVideo", (url) => {
            try {
              if (url) {
                if (flvPlayer) {
                  flvPlayer.detachMediaElement();
                  flvPlayer.destroy();
                  flvPlayer = null;
                }
                if (hlsPlayer) hlsPlayer.stopLoad();
                videoElement.src = "";
                videoElement.srcObject = null;
                //videoElement.stop();
                let bPlay = false;
                let arrStr = url.split("?");
                if (arrStr && arrStr.length > 0) {
                  let len = arrStr[0].length;
                  if (len < 4) return;
                  let name = arrStr[0].substr(len - 3, 3);
                  if (name == "flv" && flvjs.isSupported()) {
                    flvPlayer = flvjs.createPlayer({ type: "flv", url: url });
                    flvPlayer.attachMediaElement(videoElement);
                    flvPlayer.load();
                    flvPlayer.play();
                    console.log(flvPlayer);
                    bPlay = true;
                  } else if (url.indexOf("mp4") >= 0) {
                    videoElement.src = url;
                    bPlay = true;
                  }
                  name = arrStr[0].substr(len - 4, 4);
                  if (name == "m3u8" && Hls.isSupported()) {
                    hlsPlayer.attachMedia(videoElement);
                    hlsPlayer.loadSource(url);
                    videoElement.play();
                    bPlay = true;
                  }
                  if (!bPlay) {
                    if (url.indexOf("video") == 0) {
                      let video = document.getElementById(url);
                      if (video) {
                        videoElement.srcObject = video.srcObject;
                        bPlay = true;
                      }
                    }
                  }
                }
                if (bPlay) {
                  videoElement.play();
                }
              }
            } catch (e) {
              console.log(e);
            }
          });

          var info = JSON.parse(localStorage.getItem("info"));
          if (!info.type) {
            login({
              acount: info.acount,
              psd: info.psd,
            }).then((res) => {
              console.log(res);
              if (res.code == 1) {
                that.$message.error(res.error);
                setTimeout(() => {
                  localStorage.removeItem("info");
                  location.reload();
                }, 500);

                return;
              }

              if (res.black == 1) {
                that.$message.error("你已被拉入黑名单");
                setTimeout(() => {
                  localStorage.removeItem("info");
                  location.reload();
                }, 500);
              }

              that.$chat.role.auth = res.auth;
              that.$chat.role.name = res.name;
              that.$chat.role.id = res.id;
              (that.$chat.user_group = res.group_id), (that.$chat.user_power = res.auth);
              that.$chat.login(that.$chat.role);
              // that.$client.login(that.$chat.role.name);

              Bus.$emit("check", "");
            });
          } else {
            that.$chat.role.auth = 1;
            that.$chat.role.type = true;
            that.$chat.role.name = info.name;
            that.$chat.login(that.$chat.role);
            // that.$client.login(that.$chat.role.name);
          }
        };
        function on_close_lable() {
          if (_o2.current_solution != "") {
            active_solution("");
          }
          _o2.active_software("");
        }
        _o2.on_close_lable = on_close_lable;
        function add_lable_to_char(object, name) {
          let canvas = document.createElement("canvas");
          canvas.width = 160;
          canvas.height = 32;
          const drawingContext = canvas.getContext("2d");
          drawingContext.fillStyle = "#000000";
          drawingContext.globalAlpha = 0.8;
          drawingContext.fillRect(0, 0, 160, 32);
          drawingContext.globalAlpha = 1;
          drawingContext.fillStyle = "#ffffff";
          drawingContext.font = "24px Georgia";
          drawingContext.textAlign = "center";
          drawingContext.fillText(name, 80, 24);

          let map = new THREE.CanvasTexture(canvas);
          let sprite = new THREE.Sprite(
            new THREE.SpriteMaterial({ map: map, color: "#ffffff" })
          );
          sprite.position.set(0, 1900, 0);
          sprite.scale.set(600, 120, 1);
          sprite.material.depthWrite = false;
          object.add(sprite);
          return map;
        }
        _o2.add_lable_to_char = add_lable_to_char;
        function update_char_name(obj, name) {
          for (let i = 0; i < obj.children.length; i++) {
            let child = obj.children[i];
            if (child.type == "Sprite") {
              obj.remove(child);
              break;
            }
          }
          _o2.add_lable_to_char(obj, name);
        }
        _o2.update_char_name = update_char_name;
        function add_video_stream_to_char(obj, id) {
          if (!obj) return;
          if (obj.children) {
            for (let i = 0; i < obj.children.length; i++) {
              let e = obj.children[i];
              if (e.name == "videoSprite" && e.isSprite) {
                return;
              }
            }
          }
          let div = document.getElementById(id);
          console.log(div);
          if (div) {
            let arr = div.getElementsByTagName("video");
            console.log(arr.length);
            if (arr && arr.length > 0) {
              let video = arr[0];
              let tex = new THREE.VideoTexture(video);
              let sprite = new THREE.Sprite(
                new THREE.SpriteMaterial({ map: tex, color: "#ffffff" })
              );
              sprite.name = "videoSprite";
              obj.add(sprite);
              sprite.position.set(0, 2500, 0);
              sprite.scale.set(800, 600, 1);
            }
          }
        }
        _o2.add_video_stream_to_char = add_video_stream_to_char;
        function onRemoteStreamAdd(id) {
          if (_o2.players) {
            for (let i = 0; i < _o2.players.length; i++) {
              let e = _o2.players[i];
              if (e.name == id) {
                _o2.add_video_stream_to_char(e.object, id);
              }
            }
          }
        }
        _o2.onRemoteStreamAdd = onRemoteStreamAdd;

        function onLocalStreamAdd() {
          if (_o2.player) {
            _o2.add_video_stream_to_char(_o2.player, "local_stream");
          }
        }
        _o2.onLocalStreamAdd = onLocalStreamAdd;
      }

      ppp.then(() => {
        console.log("load ended");
        if (_o2.onSceneLoaded) {
          _o2.onSceneLoaded();
        }
      });
    },
  },
  created() {},
  mounted() {
    //在模板编译完成后执行
    this.start3D();
  },
};
</script>

<style>
#mainview,
#container {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.el-main {
  padding: 0 !important;
  background-color: #e9eef3;
  color: #333;
  height: 100%;
}
</style>
